<vl-widget-title [text]="'stats_ligne.articles_produits_ligne' | trans" [widget]="widget()">
  <ng-content/>
  <vl-aide-context [sections]="aideSections"/>
</vl-widget-title>

@if (stats() === null) {
  <vl-loader-skeleton/>
} @else if (chartData().labels.length) {
  <div class="flex-row w100 widget-content fade-in">
    <div class="w40 overflow-hidden">
      <canvas #articlesChart></canvas>
    </div>
    <div class="flex-col w60 overflow-scroll gap-4">
      @if (legendLabels()) {
        @for (label of legendLabels(); track label.label) {
          <div class="flex-row gap-8 p-8 border-on-disabled border-box border-8 align-center wrap">
            <span [style.background-color]="label.color" class="w-16 h-16 border-full shrink-0"></span>
            <span class="grow caption on-background-alt ellipsis">{{ label.label }}</span>
            <span class="caption on-disabled shrink-0">{{ label.percentage | numberSig:{minDecimals: 0, maxDecimals: 1} }}%</span>
          </div>
        }
      }
    </div>
  </div>
} @else {
  <div class="flex-row align-center justify-center h100 on-disabled">
    {{ 'stats_ligne.aucune_donnee' | trans }}
  </div>
}
